'use strict';

/**
 * Model of an object for the review process
 *
 * @category   Model
 * @module     import
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoModel = require('base/Colido.Model');

var ReviewObjectModel = ColidoModel.extend({});

module.exports = ReviewObjectModel;